// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button_div {
  width: 50px;
  display: flex;
  align-items: center;
}

.mat-column-dataHoraEvento {
  width: 12em;
}

.mat-column-descTipoEvento {
  width: 20em;
}

.mat-column-actions {
  width: 12em;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/evento-list-modal/evento-list-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;AACJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ","sourcesContent":[".button_div {\r\n    width: 50px;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n\r\n.mat-column-dataHoraEvento {\r\n    width: 12em;\r\n}\r\n\r\n.mat-column-descTipoEvento {\r\n    width: 20em;\r\n}\r\n\r\n.mat-column-actions {\r\n    width: 12em;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
